import React from 'react';
import { Form, Input, DatePicker } from 'antd';
import locale from 'antd/lib/date-picker/locale/ru_RU';
const { Group } = Input;

const RequestCreationPeriod = ({ form }) => {
  const { getFieldDecorator, getFieldValue } = form;
  const creationPeriodDateFromValue = getFieldValue('creationPeriodDateFrom');
  const creationPeriodDateToValue = getFieldValue('creationPeriodDateTo');
  return (
    <Form.Item label="Период создания заявки:" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('creationPeriodDateFrom')(
          <DatePicker
            locale={locale}
            disabledDate={startValue =>
              creationPeriodDateToValue &&
              startValue.valueOf() > creationPeriodDateToValue.valueOf()
            }
            style={{ width: '50%' }}
            placeholder="от"
            format={'DD.MM.YYYY'}
          />
        )}
        {getFieldDecorator('creationPeriodDateTo')(
          <DatePicker
            locale={locale}
            disabledDate={endValue =>
              creationPeriodDateFromValue &&
              endValue.valueOf() <= creationPeriodDateFromValue.valueOf()
            }
            style={{ width: '50%' }}
            placeholder="до"
            format={'DD.MM.YYYY'}
          />
        )}
      </Group>
    </Form.Item>
  );
};

export default RequestCreationPeriod;
